import React from "react";
import { useSelector } from "react-redux";
import NumberDisplay from "../../../../components/numberDisplay/numberDisplay";

const ClosingMonthToDate = () => {
  const value = useSelector((state) => state.firstRiders.firstTimeRiders?.closing?.closingMTD);
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);

  return <NumberDisplay value={value} disableAnimation={isUserQa} />;
};

export default ClosingMonthToDate;
